import { useNavigate } from 'react-router';
import { OutlineChevronLeftIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import history from '~/browserHistory';
import { Colors } from '~/themes/colors';

export default function BackWhiteButtonLegacy({ whiteArrow, containerStyle, backRoute }) {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: 'flex',
        cursor: 'pointer',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        marginLeft: 10,
        ...containerStyle,
      }}
      onClick={() => (backRoute ? history.push(backRoute) : navigate(-1))}
    >
      <OutlineChevronLeftIcon
        color={whiteArrow ? colors.shades[0] : colors.secondary[500]}
        size={30}
      />
      <p
        className="global_font f-dark"
        style={{
          color: Colors.white,
          fontWeight: 'bold',
          fontSize: 22,
          textAlign: 'left',
          width: '100%',
          cursor: 'pointer',
        }}
      >
        Back
      </p>
    </div>
  );
}
